import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { QuillEditorComponent, QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'app-assessment-editor',
  templateUrl: './assessment-editor.component.html',
  styleUrls: ['./assessment-editor.component.css']
})
export class AssessmentEditorComponent implements OnInit, AfterViewInit {
 
  @Input() answeredText : string;
  @Input() questionID : number
  @Input() scored : boolean = false;
  @Input() teacherView : boolean = false
  @Input() wordLimit : number;
  @Output() textLimitExceeded = new EventEmitter<any>();
  textcount:number;
  wordCount: number = 0;  
  quill: any = {};
  gaugePercentage: number = 0;
  getGaugeColor: boolean;
  @ViewChild('editor') contentQuillEditor: QuillEditorComponent;
  @ViewChild('viewer') contentQuillViewer: QuillViewComponent;

  constructor() { }

  ngAfterViewInit(): void {
    // if(!this.teacherView){
    //   this.contentQuillEditor.onEditorCreated.subscribe(() => {
    //     this.quill = this.contentQuillEditor.quillEditor;
    //   });
    // }
    this.checkCount();
  }

  ngOnInit(): void {
    // if(!this.teacherView){
    //     setTimeout( () => { this.quill.root.innerHTML = this.answeredText; }, 200);
    // }     
  }
 
  checkCount() {    
    if(this.wordLimit > 0){      
      this.textcount = this.wordCount = this.countWords();  
      let progress = this.wordCount / this.wordLimit;
      //progress bar
      if (progress <= 1){
        this.gaugePercentage = progress * 100;
        this.getGaugeColor = true;
      }
      else{
        this.gaugePercentage = 100;
        this.getGaugeColor = false;
      }
      if (this.wordCount > this.wordLimit) {
        let data = {exceed: true, id: this.questionID}
        this.textLimitExceeded.emit(data);  // Notify the parent component
      } else {
        let data = {exceed: false, id: this.questionID}
        this.textLimitExceeded.emit(data); // Notify the parent component that text is now within the limit
      }
    } 
  }

  countWords(): number {
    let text;
    if(this.teacherView)
      text = this.contentQuillViewer.quillEditor.getText();
    else
      text = this.contentQuillEditor.quillEditor.getText();    

    return text.split(/\s+/).filter(Boolean).length;
  }
}
